import { TableName } from '../../constants/table';
import { doesEntityExist } from '../../lib/services/api-service';

export const validateCommonCode = async (
  tenantId: string,
  value: string
): Promise<boolean> => {
  const exists = await doesEntityExist(TableName.CommonCode, tenantId, value);
  return !exists;
};
